import fetchServer from "../helpers/api/fetchServer";

export const createCallToAction = async ({
  name,
  nameFrench,
  adPlatformCode,
  adPlatformId,
}) => {
  const method = "POST";
  const urlAPI = "/api/callToActions";
  const body = {
    name,
    nameFrench,
    adPlatformCode,
    adPlatform: adPlatformId,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const getCallToActions = async () => {
  const method = "GET";
  const urlAPI = "/api/callToActions";
  return await fetchServer({ method, urlAPI });
};

export const getCallToActionsByAdPlatform = async (adPlatformId) => {
  const method = "GET";
  const urlAPI = `/api/callToActions?adPlatform=${adPlatformId}`;
  return await fetchServer({ method, urlAPI });
};

export const getCallToAction = async (id) => {
  const method = "GET";
  const urlAPI = `/api/callToActions/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const updateCallToAction = async ({
  id,
  name,
  nameFrench,
  adPlatformCode,
  adPlatformId,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/callToActions/${id}`;
  const body = {
    name,
    nameFrench,
    adPlatformCode,
    adPlatform: adPlatformId,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const deleteCallToAction = async (id) => {
  const method = "DELETE";
  const urlAPI = `/api/callToActions/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const restoreCallToAction = async (id) => {
  const method = "POST";
  const urlAPI = `/api/callToActions/${id}/restore`;
  return await fetchServer({ method, urlAPI });
};

export const deleteCallToActions = async (ids) => {
  const method = "POST";
  const urlAPI = "/api/callToActions/bulk-delete";
  const body = {ids};
  return await fetchServer({ method, urlAPI, body });
};

export const restoreCallToActions = async (ids) => {
  const method = "POST";
  const urlAPI = "/api/callToActions/bulk-restore";
  const body = {ids};
  return await fetchServer({ method, urlAPI, body });
};
